/**
 * Условия возврата для клиентов группы. Значения повторяют
 * `Modules\\OrderReturn\\Enum\\ReturnTermsEnum` на бэкенде.
 */
export const RETURN_TERMS = ["standard", "dealer", "dealer_excluded"] as const;

export type ReturnTerms = (typeof RETURN_TERMS)[number];
